module.exports = __webpack_public_path__ + "img/pcModalTip_icon.1ac77e04.png";